import {Injectable} from '@angular/core';
import {environment} from '../../../../../environments/environment';
import {Report} from '../../interfaces/Report';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';
import {Pagination} from '../../../utilities/interfaces/Pagination';
import {ReportView} from '../../interfaces/ReportView';

@Injectable()
export class ReportService {

  protected route = 'report-template';
  protected subRoute = 'report';
  protected viewRoute = 'view';
  constructor(private http: AuthHttp) {}

  public getReports(reportTemplateId, reportViewId,
                    limit: number = 10, page = 1,
                    airlineId?: number, airportId?: number, regionId?: number):
  Promise<Pagination<Report>> {
    const params: any = {
      limit: limit,
      page: page
    };
    if (airlineId)
      params['airline_id'] = airlineId;
    if (airportId)
      params['airport_id'] = airportId;
    if (regionId)
      params['region_id'] = regionId;
    return this.http
      .get(`${environment.baseUrl}${this.route}/${reportTemplateId}/${this.viewRoute}/${reportViewId}/${this.subRoute}`,
      {params: params})
      .map((res) => res.json())
      .map((reports: Pagination<Report>) => ({
        ... reports,
        data: reports.data.map((report) => ({
            ...report,
            date: this.getTime(report.date)
        }))
      })).toPromise();
  }


  public getReportViews(reportTemplateId, limit: number = 10, page = 1): Promise<Pagination<ReportView>> {
    const params: any = {
      limit: limit,
      page: page
    };
    return this.http
      .get(`${environment.baseUrl}${this.route}/${reportTemplateId}/${this.viewRoute}`, {params: params})
      .map((res) => res.json())
      .toPromise();
  }

  public getReportView(reportViewId): Promise<ReportView> {
    return this.http
      .get(`${environment.baseUrl}${this.viewRoute}/${reportViewId}`)
      .map((res) => res.json())
      .toPromise();
  }

  protected getTime(dateString): string {
    const date = new Date(dateString + ' GMT');
    return  date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  }

  public create(reportTemplateId, reportViewId, airlineId?: number, airportId?: number, regionId?: number) {
    const data: any  = {};
    if (airlineId)
      data['airline_id'] = airlineId;
    if (airportId)
      data['airport_id'] = airportId;
    if (regionId)
      data['region_id'] = regionId;
    return this.http
        .post(`${environment.baseUrl}${this.route}/${reportTemplateId}/${this.viewRoute}/${reportViewId}/${this.subRoute}`,
        data)
        .map((res) => res.json())
        .toPromise();
  }
  public show(id: number) {
    return this.http
      .get(`${environment.baseUrl}${this.subRoute}/${id}`)
      .map((res) => res.json())
      .toPromise();
  }

  public getExportUrl(id: number) {
    return encodeURI(`${environment.baseUrl}${this.subRoute}/${id}/export?token=${this.http.getTokenBearer()}`);
  }

  public delete(reportTemplateId, reportViewId, id) {
    return this.http
        .delete(`${environment.baseUrl}${this.route}/${reportTemplateId}/${this.viewRoute}/${reportViewId}/${this.subRoute}/${id}`)
        .toPromise();
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/report/services/report/report.service.ts